/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

const LOCALISED_TOKEN_OPTIONS = {
    lll: { dateStyle: 'medium', timeStyle: 'short' },
    LL: { dateStyle: 'long' },
    L: { dateStyle: 'short' }
};

/**
 * Formats a date using a moment-style token mapped to Intl.DateTimeFormat options.
 *
 * @param {string|number|Date} date - Date to format; a missing or invalid value yields an empty string.
 * @param {string} token - Supported format token (`lll`, `LL`, `L`); unknown tokens fall back to `lll`.
 * @param {string} locale - BCP 47 locale tag passed to Intl.DateTimeFormat.
 * @returns {string} The localized date string, or an empty string when the date is invalid.
 */
export function formatMyDate(date, token, locale) {
    const parsed = new Date(date);
    if (!date || Number.isNaN(parsed.getTime())) {
        return '';
    }
    const options = LOCALISED_TOKEN_OPTIONS[token] ?? LOCALISED_TOKEN_OPTIONS.lll;
    return new Intl.DateTimeFormat(locale, options).format(parsed);
}
